import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import {
    selectConfigValuesEditLoadingStatus,
    selectConfigValuesEditLoadedAssetId,
    selectConfigValuesEditLoadedClientId,
    selectConfigValuesEdit,
    fetchEditConfigValues,
    selectConfigValuesEditForDisplay,
} from 'features/configValues/configValuesSlice';
import { useConfigFields } from './useConfigFields';

export function useEditConfigValues({ clientId, assetId }) {
    const dispatch = useDispatch();

    const {
        validationTypesLoadingStatus,
        configFieldsLoadingStatus,
        configFields,
        validationTypes,
        validationRawTypes,
    } = useConfigFields();

    const configValuesLoadingStatus = useSelector(selectConfigValuesEditLoadingStatus);
    let configValues = useSelector((state) => selectConfigValuesEditForDisplay(state, clientId, assetId, configFields));
    const configLoadedAssetId = useSelector(selectConfigValuesEditLoadedAssetId);
    const configLoadedClientId = useSelector(selectConfigValuesEditLoadedClientId);
    const selectedConfigValues = useSelector(selectConfigValuesEdit);

    useEffect(() => {
        const fetchConfigValues = async () => {
            if (clientId !== configLoadedClientId || assetId !== configLoadedAssetId || !selectedConfigValues) {
                // dispatch(
                //     setConfigLoadedAssetClient({
                //         assetId: assetId,
                //         clientId: clientId,
                //     })
                // );
                return await dispatch(fetchEditConfigValues({ clientId, assetId }));
            }
        };

        if (
            validationTypesLoadingStatus === LoadingStatus.Loaded &&
            configFieldsLoadingStatus === LoadingStatus.Loaded
        ) {
            fetchConfigValues();
        }
    }, [
        validationTypesLoadingStatus,
        configFieldsLoadingStatus,
        clientId,
        assetId,
        configLoadedClientId,
        configLoadedAssetId,
        selectedConfigValues,
        dispatch,
    ]);

    return {
        configValuesLoadingStatus,
        configFieldsLoadingStatus,
        validationTypesLoadingStatus,
        configValues,
        configFields,
        validationTypes,
        validationRawTypes,
    };
}
